import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LaunchIcon(props: IconProps) {
    return <Icon {...props} iconKey={"launch"}/>
}
